import { accountPriorityOptions } from '../../../../common/constants/select-options/accountPriority.consts';
import { isEmpty } from '../../../../common/utils/helpers';
import { City } from '../../../City/models/City';
import { ClosingSource } from '../../../ClosingSources/model/ClosingSource';
import { KeyAccountGroupsResponse } from '../../../KeyAccountGroups/models/key-account-groups-response';
import { RestaurantRequest } from '../../models';
import { Deliverers } from '../../models/restaurant-deliverers.model';
import { statusSelectOptions } from '../../RestaurantForm/RestaurantForm.form';
import { RestaurantChangesSummary } from '../model/restaurant-changes-summary.model';
import { UpdateRestaurantsRequest } from '../model/update-restaurants.request.model';

const buildDeliverers = (deliverersEntry?: Deliverers): Deliverers => {
  const deliverers: Deliverers = {};
  if (!isEmpty(deliverersEntry?.wolt)) {
    deliverers.wolt = deliverersEntry?.wolt;
  }
  if (!isEmpty(deliverersEntry?.lieferando)) {
    deliverers.lieferando = deliverersEntry?.lieferando;
  }
  if (!isEmpty(deliverersEntry?.uberEats)) {
    deliverers.uberEats = deliverersEntry?.uberEats;
  }
  if (!isEmpty(deliverersEntry?.customDelivery)) {
    deliverers.customDelivery = deliverersEntry?.customDelivery;
  }
  return deliverers;
};

export const buildUpdateRestaurantsRequest = (formData: RestaurantRequest): UpdateRestaurantsRequest => {
  const {
    googlePlaceId,
    tags,
    promotions,
    metaCategories,
    restaurantOpeningHours,
    overrideOpeningHours,
    deliverers,
    ...remainingFields
  } = formData;
  const updateRestaurantsRequest: UpdateRestaurantsRequest = Object.fromEntries(
    Object.entries(remainingFields).filter(([, value]) => !!value && value != ''),
  );
  const deliverersRequest = buildDeliverers(deliverers);
  if (!isEmpty(deliverersRequest)) {
    updateRestaurantsRequest.deliverers = deliverersRequest;
  }
  if (overrideOpeningHours) {
    updateRestaurantsRequest.overrideOpeningHours = overrideOpeningHours;
    updateRestaurantsRequest.restaurantOpeningHours = restaurantOpeningHours;
  }
  return updateRestaurantsRequest;
};

export const buildRestaurantChangesSummaryObject = (
  updateRestaurantsRequest: UpdateRestaurantsRequest,
  city?: City,
  keyAccount?: KeyAccountGroupsResponse,
  closingSource?: ClosingSource,
): RestaurantChangesSummary => {
  const {
    status,
    starterSetSize,
    deliverers,
    accountPriority,
    cityId,
    keyAccountId,
    closingSourceId,
    overrideOpeningHours,
    address,
    ...remainingFields
  } = updateRestaurantsRequest as UpdateRestaurantsRequest;

  let citySummaryText = city?.translations.en;
  if (city?.country) {
    citySummaryText += `, ${city?.country?.translations.en}`;
  }

  const restaurantChangesSummary = {
    ...remainingFields,
    ...(address ? { street: address.street } : {}),
    ...(address ? { streetNumber: address.streetNumber } : {}),
    ...(address ? { postalCode: address.postalCode } : {}),
    status: statusSelectOptions.find((option) => option.value === status)?.label,
    starterSetSize: starterSetSize?.toString(),
    accountPriority: accountPriorityOptions.find((option) => option.value === accountPriority)?.label,
    woltLink: deliverers?.wolt?.url,
    lieferandoLink: deliverers?.lieferando?.url,
    uberEatsLink: deliverers?.uberEats?.url,
    orderingSystemLink: deliverers?.customDelivery?.url,
    city: citySummaryText,
    fnbGroup: keyAccount?.keyAccount,
    closingSource: closingSource?.name,
  };
  return Object.fromEntries(
    Object.entries(restaurantChangesSummary).filter(([, value]) => !!value && value != ''),
  ) as RestaurantChangesSummary;
};

export const toSentenceCase = (camelCase: string): string => {
  const result = camelCase.replace(/([A-Z])/g, ' $1');
  return result.toLowerCase();
};
